<template>
    <div class="roothome">
        <div class="title2">
            <!--Links-->
            <div class="wrapper1" style="height: 100%; margin-bottom: 2.5vh;">
                <!--<span class="tx_title">NOSSOS LINKS:</span>-->
                <span class="tx_title">BAIXE NOSSO APLICATIVO E TENHA A PARAÍBA NA PALMA DA SUA MÃO</span>
                <a style="display: flex; justify-content: center;" href="https://play.google.com/store/apps/details?id=com.adviceparaibaguide" target="_blank">
                    <img class="im_redes" src="/static/imgs/ic_redes_google.png"/>
                </a>
                <a style="display: flex; justify-content: center; margin-bottom: 2.5vh;" href="https://apps.apple.com/br/app/advice-para%C3%ADba/id1641401376" target="_blank">
                    <img class="im_redes" src="/static/imgs/ic_redes_apple.png"/>
                </a>

                <a class="bt_link1" href="https://adviceparaiba.com" target="_blank">
                    <div class="bt_link2">
                        <img class="im_bt" src="/static/imgs/ic_globo.png"/>
                        <span class="tx_bt">adviceparaiba.com</span>
                    </div>
                </a>
                <a class="bt_link1" href="https://instagram.com/adviceparaiba" target="_blank">
                    <div class="bt_link2">
                        <img class="im_bt" src="/static/imgs/ic_insta_2024.png"/>
                        <span class="tx_bt">@adviceparaiba</span>
                    </div>
                </a>
            </div>

            <!--Phone-->
            <div class="wrapper2" style="justify-content: flex-end">
                <img class="im_phone" src="/static/imgs/phone.png"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { advMixin } from '../scripts/advMixin'

    export default {
        // mixins: [advMixin],
        name: 'Links',
        data () {
            return {
                name: 'Links',
            }
        },
        methods: {
            shuffle(array) {
                var tmp, current, top = array.length;
                if(top) while(--top) {
                    current = Math.floor(Math.random() * (top + 1));
                    tmp = array[current];
                    array[current] = array[top];
                    array[top] = tmp;
                }
                return array;
            }
        },
        created() {
            console.log(this.name + '::created!!');

            console.log(this.name + '::Terminei o created!!');
        },
        beforeMount() {
            console.log(this.name + '::beforeMount!!');

            console.log(this.name + '::Terminei o beforeMount!!');
        },
        mounted() {
            console.log(this.name + '::mounted!!');

            console.log(this.name + '::Terminei o mounted!!');
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .roothome {
        background-color: #0C589A;
        overflow-y: scroll;
        height: 100vh;
        display: flex;
        /*flex-direction: column;*/
        justify-content: center;
        align-items: flex-start;
    }
    .roothome::-webkit-scrollbar {
        /* This is the magic bit */
        display: none;
    }

    .title2 {
        display: flex;
        width: 100%;
        flex-direction: row;
        /*background-color: pink;*/
        justify-content: center;
        align-items: center;
    }

    .wrapper1, .wrapper2 {
        height: 100vh;
        /*background-color: red;*/
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        align-content: center;
        width: 40%;
        margin-right: 3%;
        margin-left: 3%

    }

    .bt_link1 {
        width: 60%;
        margin-top: 1vh;
        background-color: #2AABF2;
        display: flex;
        border-radius: 50px;
        padding: 2px;
    }
    .bt_link2 {
        width: 100%;
        background-color: #2AABF2;
        display: flex;
        border-radius: 50px;
        padding-left: 5%;
        border-color: white;
        border-style: solid;
        border-width: 1px;
        align-items: center;
    }

    .tx_title {
        text-align: center;
        font-weight: bold;
        color: white;
        font-size: 2.3vw;
        margin-bottom: 2.5vh;
        margin-top: 2.5vh;
    }

    .tx_bt {
        color: white;
        font-size: 1.8vw;
        /*background-color: pink;*/
    }

    .im_redes {
        width: 70%;
    }

    .im_bt {
        width: 12%;
        margin-right: 4%;
        object-fit: contain;
    }

    .im_phone {
        width: 100%;
    }


    /* celular */
    @media (max-width:1000px)  {
        .title2 {
            flex-direction: column;
            width: 90%;
            height: 100%;
            justify-content: space-between;
            align-content: flex-start;
        }
        .wrapper1, .wrapper2 {
            width: 70%;
            height: unset;
        }
        .wrapper1 {
            width: 80%;
            /*background-color: red;*/
        }
        .bt_link1 {
            width: 70%;
        }
        .tx_title {
            font-size: 4.5vw;
        }
        .tx_bt {
            font-size: 5vw;
        }
    }

    @media screen and (min-width: 1200px) {
        .title2 {
            width: 90%;
        }
        .wrapper1 {
            width: 40%;
        }
        .wrapper2 {
            width: 28%;
        }
    }

    @media screen and (min-width: 1400px) {
        .title2 {
            width: 80%;
        }
        .wrapper1 {
            width: 40%;
        }
        .wrapper2 {
            width: 38%;
        }
        .tx_title {
            font-size: 1.7vw;
        }
    }
    @media screen and (min-width: 1600px) {
        .title2 {
            width: 70%;
        }
        .wrapper2 {
            width: 40%;
        }
        .tx_title {
            font-size: 1.6vw;
        }
    }
    @media screen and (min-width: 1900px) {
        .title2 {
            width: 60%;
        }
        .tx_title {
            font-size: 1.5vw;
        }
        .tx_bt {
            font-size: 1.5vw;
        }
    }

    @media screen and (min-width: 2200px) {
        .title2 {
            width: 50%;
        }
        .tx_title {
            font-size: 1.2vw;
        }
        .tx_bt {
            font-size: 1vw;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/links.vue